(function () {
  function init() {
    var form = document.getElementById('add-to-cart-form');
    if (!form) return;
    var status = form.querySelector('[data-ocu-price-status]');
    var prices = form.querySelector('.prices');
    if (!status || !prices || status.dataset.ocuPriceReady) return;
    status.dataset.ocuPriceReady = 'true';
    var timer;
    function readPrice() {
      var price = prices.querySelector('.price');
      return price ? price.textContent.replace(/\s+/g, ' ').trim() : '';
    }
    var lastPrice = readPrice();
    var message = status.getAttribute('data-ocu-price-announcement');
    function announce() {
      var price = readPrice();
      if (!price || price === lastPrice) return;
      lastPrice = price;
      status.textContent = message.replace('__PRICE__', price);
    }
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(announce, 250);
    }).observe(prices, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
